export default __webpack_public_path__ + "be295e5fd5b194bb887e4f4cf83facb8.png";